import React from "react";
import {
  View,
  StyleSheet,
  Platform,
  ViewStyle,
  TouchableOpacity,
} from "react-native";
import variables from "../../../../styles/variables";
import { useResponsive } from "../../../../hooks/useResponsive";
import RText from "../../../RText";
import Icon from "../../../Icon";
import ChevronIcon from "../../../ChevronIcon/ChevronIcon";
import usePressableProps from "../../../../hooks/usePressableProps";

const { colors, spacing } = variables;

type HeaderProps = {
  heading: string;
  type: "tipster" | "tipster-expert" | "info" | "race";
  style?: ViewStyle;
  rightComponent?: {
    text?: string;
    chevron?: boolean;
  };
  subHeading?: string;
  rtvTrack?: boolean;
  screen?: string;
  params?: Object;
};

const TipsterHeader = ({
  heading,
  subHeading,
  rightComponent,
  type,
  style = {},
  rtvTrack,
  screen = "IndividualTipster",
  params,
}: HeaderProps) => {
  const { isLargeAndUp } = useResponsive();

  const pressableProps =
    screen &&
    params &&
    usePressableProps({
      screen: screen,
      params: params,
    });

  if (!heading) return;

  return (
    <TouchableOpacity style={[styles.container, style]} {...pressableProps}>
      <View
        style={[
          styles.leftContainer,
          {
            paddingVertical: isLargeAndUp ? spacing.xsmall : spacing.xxsmall,
          },
        ]}
      >
        <Icon
          name={type === "tipster-expert" ? "eye" : "hat"}
          size="small"
          style={styles.tipsterIcon}
        />
        <View style={type == "race" && styles.race}>
          <View style={styles.heading}>
            <RText
              color="primary"
              family="secondary"
              weight="bold"
              uppercase
              size="md"
            >
              {heading}
            </RText>
            {rtvTrack && (
              <Icon name="rLogo" size="small" style={styles.rIcon} />
            )}
          </View>
          {!!subHeading && (
            <RText family="secondary" size="sm" style={styles.subHeading}>
              {subHeading}
            </RText>
          )}
        </View>
      </View>
      {/* bio one liner for bigger screens */}
      {rightComponent ? (
        <View style={styles.rightContainer}>
          {rightComponent.text && (
            <RText style={styles.rightText}>{rightComponent.text}</RText>
          )}
          {rightComponent.chevron && (
            <View style={styles.chevron}>
              <ChevronIcon type="right" />
            </View>
          )}
        </View>
      ) : null}
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  container: {
    marginTop: 8,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: colors.palette.neutral.x100,
    cursor: Platform.OS == "web" ? "pointer" : "default",
    paddingHorizontal: spacing.xxsmall,
    width: "100%",
  },
  leftContainer: {
    flexDirection: "row",
    alignItems: "center",
  },
  tipsterIcon: {
    marginHorizontal: spacing.xxsmall,
  },
  race: {
    marginHorizontal: spacing.xxsmall,
  },
  heading: {
    flexDirection: "row",
  },
  rIcon: {
    marginLeft: 6,
    paddingTop: 1,
  },
  subHeading: {
    marginTop: spacing.xxsmall,
    maxWidth: 850,
  },
  expertEyeIcon: {
    marginLeft: spacing.xxsmall,
  },
  rightContainer: {
    flexDirection: "row",
    alignItems: "flex-end",
    justifyContent: "center",
  },
  rightText: {
    marginHorizontal: spacing.xsmall,
    height: 24,
  },
  chevron: {
    paddingBottom: 1,
  },
});

export default TipsterHeader;
